/* eslint semi:0 */
import { noop, } from 'utils/fn'
import { node, body, } from 'utils/dom'
import { warn, } from 'application/console'
import { SELECTORS, } from 'config/preRenderedSelectorsConfig'
import { isSupportedForDomain, } from 'application/pageDataObject'


const HAMBURGER_FEATURE_ID = 'HamburgerMenu'
const HAMBURGER_CLASS_NAMES = {
  NO_SCROLL: 'no-scroll',
}
const CHECKED_MENU_RADIO_BUTTON_SELECTOR = "input[name=leagues-list-radio]:checked"

const w = window

function calculateHamburgerHeight(header, sideNav){
  const elemRect = header.getBoundingClientRect()
  const headerBottom = elemRect.bottom
  const hamburgerOpenedHeight = `${ Math.max(document.documentElement.clientHeight, w.innerHeight || 0) - headerBottom }px`
  sideNav.menu.style.height = hamburgerOpenedHeight
  return this
}

function uncheckCheckedSidenav(sideNav, e){
  if (sideNav.checkbox && sideNav.checkbox.checked) {
    sideNav.hamburger.click()
    const checkedMenuButton = node(CHECKED_MENU_RADIO_BUTTON_SELECTOR)
    if (checkedMenuButton) {
      checkedMenuButton.checked = false
    }
  }
}

function menuClickHandler(sideNav, e){
  if (e.target.classList.contains(SELECTORS.MAIN_SIDENAV_TOGGLE.slice(1))) {
    calculateHamburgerHeight(sideNav.headerNode, sideNav)
  }
  body.classList.toggle(HAMBURGER_CLASS_NAMES.NO_SCROLL, sideNav.checkbox.checked)
  e.stopPropagation()
}

function registerClickEvents(sideNav, element){
  if (!element) {
    warn('[hamburger] registerClickEvents got a falsy element', { sideNav, element, })
    return noop
  }
  const partiallyAppliedClickHandler = menuClickHandler.bind(0, sideNav)
  element.addEventListener('click', partiallyAppliedClickHandler)
  return partiallyAppliedClickHandler
}

function addHamburgerEventListeners(){
  const sideNav = {
    headerNode: node(SELECTORS.SITE_HEADER),
    checkbox: node(SELECTORS.MAIN_SIDENAV_CHECKBOX),
    hamburger: node(SELECTORS.MAIN_SIDENAV_TOGGLE),
    menu: node(SELECTORS.MAIN_SIDENAV),
  }
  body.addEventListener('click', uncheckCheckedSidenav.bind(0, sideNav))
  const clickEventTargets = [sideNav.menu, sideNav.hamburger, sideNav.checkbox, ]
  return clickEventTargets.map(registerClickEvents.bind(0, sideNav))
}

export function registerHamburger(){
  const shouldInitHamburgerMenu = isSupportedForDomain(HAMBURGER_FEATURE_ID)
  if (shouldInitHamburgerMenu) {
    addHamburgerEventListeners()
  }
  return shouldInitHamburgerMenu
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/hamburger/hamburger.js